import { render, staticRenderFns } from "./taskTable.vue?vue&type=template&id=e532b3ec&scoped=true"
import script from "./taskTable.vue?vue&type=script&lang=js"
export * from "./taskTable.vue?vue&type=script&lang=js"
import style0 from "./taskTable.vue?vue&type=style&index=0&id=e532b3ec&prod&scoped=true&lang=css"
import style1 from "./taskTable.vue?vue&type=style&index=1&id=e532b3ec&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e532b3ec",
  null
  
)

export default component.exports